import { Box, List, styled, Text, alpha } from '@ltvco/refresh-lib/theme';

import { transparentScrollbar } from 'components/ChatBV/styleMixins';

export const StyledConversationList = styled(List, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})(({ collapsed }: { collapsed: boolean }) => ({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  opacity: collapsed ? 0 : 1,
  transition: 'opacity 0.3s ease-in-out',
  transitionDelay: collapsed ? '0s' : '0.1s',
  flex: 1,
  minHeight: 0,
  boxSizing: 'border-box',
  ...transparentScrollbar,
}));

export const StyledConversationListItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => {
  const darkerHoverColor = alpha(theme.palette.primary.main, 0.25);

  return {
    width: '100%',
    padding: '8px',
    cursor: 'pointer',
    flexShrink: 0,
    backgroundColor: isActive ? theme.palette.primary.light : 'transparent',
    borderRadius: '4px',
    borderLeft: isActive
      ? `3px solid ${theme.palette.primary.main}`
      : '3px solid transparent',
    marginLeft: '4px',
    boxSizing: 'border-box',
    transition:
      'background-color 0.2s ease-in-out, border-left-color 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: isActive
        ? darkerHoverColor
        : theme.palette.primary.light,
      borderLeftColor: theme.palette.primary.main,
    },
  };
});

export const StyledConversationListItemText = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  width: '100%',
  maxWidth: '100%',
  color: isActive ? theme.palette.primary.main : theme.palette.rats.main,
  fontWeight: isActive ? 600 : 400,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  display: 'block',
  transition: 'color 0.2s ease-in-out, font-weight 0.2s ease-in-out',
}));
